module.exports = __webpack_public_path__ + "img/ZWF_Michal_Ola.192321aa.jpg";